module.exports = __webpack_public_path__ + "static/media/RM1.190c7350.jpg";